module.exports = __webpack_public_path__ + "static/media/header.da27247b.png";